import './Loader.scss';
const Loader = () => {
    return(
        <div className="loader-container">Loading...</div>
    )
}

export default Loader;